import styled from 'styled-components'

export const Section = styled.section`
  margin-bottom: 16rem;

  @media (max-width: 1279px) {
    margin-bottom: 12rem;
  }
`

export const Header = styled.div`
  width: 45.5rem;
  margin-bottom: 4rem;

  @media (max-width: 767px) {
    width: 100%;
  }
`

export const List = styled.ul`
  display: grid;
  grid-template-columns: 31rem 34rem 1fr;
  column-gap: 11.5rem;
  row-gap: 5rem;

  @media (max-width: 1279px) {
    grid-template-columns: 33.3rem 33.3rem;
    column-gap: 16rem;
  }

  @media (max-width: 999px) {
    column-gap: 6rem;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    row-gap: 4rem;
  }
`

export const Item = styled.li`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  p {
    font-family: Navigo, Arial, Helvetica, sans-serif;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: #292e3d;
    font-weight: 400;
  }
`

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background-color: #ebeffe;
  width: 4rem;
  height: 4rem;
`
